import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

interface IStatusListResponse {
  status: boolean;
  message: string;
  data: string[];
}

export const useClinicToDoctorStatusListAPI = () => {
  const [statusList, setStatusList] = useState<string[]>([]);
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();

  const execute = useCallback(async () => {
    try {
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      await axios
        .get(INVENTORY_MODULE.CLINIC_TO_DOCTOR_TRANSFER_STATUSES.baseURL, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<IStatusListResponse>) => {
          if (res.data.status === true) {
            setStatusList(res.data.data ?? []);
          } else {
            setStatusList([]);
          }
        })
        .catch((e: AxiosError) => {
          captureError(e);
          setStatusList([]);
        });
    } catch (e: any) {
      toast.error("Server Error: " + e.message);
    }
  }, []);

  return { execute, statusList };
};
